var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.parametro.nome))]),_vm._v(" "+_vm._s(_vm.criterio)+" "),(_vm.parametro.required)?_c('obrigatorio'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }